<template>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                    <h4 class="header-title mb-4"><h4 class="page-title">{{$t('string.msg.product.family.list.label.title')}}</h4></h4>

                    <b-tabs>
                        <b-tab active>
                            <template v-slot:title>
                                <strong>{{$t('string.msg.truck.label')}}</strong>
                            </template>
                            <div class="table-responsive">
                                <table class="table table-centered table-hover mb-0" id="datatable">
                                    <thead>
                                        <tr>
                                            <th class="border-top-0">{{$t('string.msg.product.family.label.name')}}</th>
                                            <th class="border-top-0">{{$t('string.msg.product.family.label.type')}}</th>
                                            <th class="border-top-0">{{$t('string.msg.product.family.label.status')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-bind:key="item._id" v-for="item in itemsTruck" class="cursor-pointer" @click="selectItem(item)">
                                            <td>
                                                <i class=" mdi mdi-upload"></i>
                                                <span class="ml-2">
                                                    {{camelize(item.name)}}
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="item.type">
                                                    {{'Familia - ' + $t(item.type)}}
                                                </span>
                                            </td>
                                            <td>
                                                <span 
                                                v-bind:class="{ 'badge-success': item.status == 'ACTIVE', 'badge-danger': item.status == 'ARCHIVED' }" 
                                                class="badge badge-pill ">
                                                
                                                    {{$t(`string.msg.status.${item.status}`)}}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </b-tab>
                        <b-tab>
                            <template v-slot:title>
                                <strong>{{$t('string.msg.truck.trailler.label')}}</strong>
                            </template>
                             <div class="table-responsive">
                                <table class="table table-centered table-hover mb-0" id="datatable">
                                    <thead>
                                        <tr>
                                            <th class="border-top-0">{{$t('string.msg.product.family.label.name')}}</th>
                                            <th class="border-top-0">{{$t('string.msg.product.family.label.type')}}</th>
                                            <th class="border-top-0">{{$t('string.msg.product.family.label.status')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-bind:key="item._id" v-for="item in itemsTruckTrailler" class="cursor-pointer" @click="selectItem(item)">
                                            <td>
                                                <i class=" mdi mdi-upload"></i>
                                                <span class="ml-2">
                                                    {{camelize(item.name)}}
                                                </span>
                                            </td>
                                            <td>
                                                <span v-if="item.type">
                                                    {{'Familia - ' + $t(item.type)}}
                                                </span>
                                            </td>
                                            <td>
                                                <span 
                                                v-bind:class="{ 'badge-success': item.status == 'ACTIVE', 'badge-danger': item.status == 'ARCHIVED' }" 
                                                class="badge badge-pill ">
                                                
                                                    {{$t(`string.msg.status.${item.status}`)}}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </b-tab>
                    </b-tabs>
            </div>
        </div>
    </div>
</template>

<script>

import Controller from './CrtListFamilies';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';

export default {
  name: 'ListGroups',
  props: ["valuekey"],
    watch:{
        'valuekey'(){
        }
    },
  components: {
    Spinner,
    Toast
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        itemsTruck: [],
        itemsTruckTrailler: []
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
    let state = this;
    this.$eventHub.$on('refreshList', function(){
        state.filter();
    })
  },
  mounted(){
  }
}
</script>

<style>
</style>
